/* eslint-disable react-native/no-inline-styles */
import {Calendar, Text, CalendarViewModes, Button} from '@ui-kitten/components';
import {MomentDateService} from '@ui-kitten/moment';
import moment from 'moment';
import React, {useState} from 'react';
import {
  Dimensions,
  Image,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import CalendarStrip from 'react-native-calendar-strip';
import {leftChevronIcon, rightChevronIcon} from '../../../../assets/images';
import {px, useIsLandscape, wp} from '../../../../utils';

const dateService = new MomentDateService();

const calendarMin = moment().subtract('1', 'year').startOf('year');
const calendarMax = moment().endOf('year');

const horizontalPadding = 17;

const TopCalendar = ({selectedDate, setSelectedDate}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const isLandscape = useIsLandscape();
  const {width} = Dimensions.get('window');
  // ! possible fix for render jumps on some devices
  // ! 7 days in a week + 2 side arrow icons = 9 element in a row
  const elementWidth = isLandscape ? 50 : width / 9;

  const goToToday = () => setSelectedDate(moment.utc());

  return (
    <>
      <View
        style={[
          styles.headerContainer,
          isLandscape ? {justifyContent: 'flex-start'} : undefined,
        ]}>
        {isLandscape && (
          <Button
            appearance="outline"
            size="small"
            style={{marginHorizontal: wp(2)}}
            onPress={goToToday}>
            {'Today'}
          </Button>
        )}
        <TouchableOpacity
          onPress={() =>
            setSelectedDate(moment(selectedDate).add(-1, 'month'))
          }>
          <Image source={leftChevronIcon} style={styles.headerIcon} />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => setShowDatePicker((value) => !value)}>
          <Text style={styles.headerText}>
            {selectedDate.format('MMMM YYYY')}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => setSelectedDate(moment(selectedDate).add(1, 'month'))}>
          <Image source={rightChevronIcon} style={styles.headerIcon} />
        </TouchableOpacity>
      </View>
      {showDatePicker && (
        <Calendar
          dateService={dateService}
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            zIndex: 2,
            top: 60,
            left: 10,
          }}
          date={selectedDate}
          onSelect={(nextDate) => {
            setSelectedDate(nextDate);
            setShowDatePicker(false);
          }}
          min={calendarMin}
          max={calendarMax}
          startView={CalendarViewModes.MONTH}
        />
      )}
      <CalendarStrip
        numDaysInWeek={isLandscape ? 3 : 7}
        // numDaysInWeek Applicable only when scrollable is false.
        scrollable={!isLandscape}
        startingDate={
          isLandscape ? selectedDate.clone().add(-1, 'day') : undefined
        }
        // If false, starts week on startingDate parameter.
        useIsoWeekday={!isLandscape}
        styleWeekend={false}
        scrollerPaging
        scrollToOnSetSelectedDate
        selectedDate={selectedDate}
        onDateSelected={setSelectedDate}
        style={styles.calendar}
        headerText={selectedDate.format('dddd, MMMM DD, YYYY')}
        calendarHeaderStyle={
          isLandscape ? {display: 'none'} : {fontSize: 14, fontWeight: '400'}
        }
        dateNumberStyle={{fontSize: 16, fontWeight: '400'}}
        highlightDateNumberStyle={{fontSize: 16, fontWeight: '400'}}
        calendarHeaderPosition="below"
        calendarAnimation={{
          type: 'sequence',
          duration: Platform.OS === 'web' ? 0 : 30,
        }}
        highlightDateContainerStyle={{backgroundColor: '#FFBE0B'}}
        maxDayComponentSize={elementWidth}
        minDayComponentSize={elementWidth}
        iconContainer={{height: '100%'}}
        leftSelector={
          <TouchableOpacity
            style={{height: '100%', justifyContent: 'center'}}
            onPress={(event) => {
              event.stopPropagation();
              if (isLandscape) {
                setSelectedDate(selectedDate.clone().add(-3, 'day'));
              } else {
                setSelectedDate(selectedDate.clone().add(-7, 'day'));
              }
            }}>
            <Image
              source={leftChevronIcon}
              resizeMode="contain"
              style={{width: elementWidth - horizontalPadding, height: 25}}
            />
          </TouchableOpacity>
        }
        rightSelector={
          <TouchableOpacity
            style={{height: '100%', justifyContent: 'center'}}
            onPress={(event) => {
              event.stopPropagation();
              if (isLandscape) {
                setSelectedDate(selectedDate.clone().add(3, 'day'));
              } else {
                setSelectedDate(selectedDate.clone().add(7, 'day'));
              }
            }}>
            <Image
              source={rightChevronIcon}
              resizeMode="contain"
              style={{width: elementWidth - horizontalPadding, height: 25}}
            />
          </TouchableOpacity>
        }
      />
    </>
  );
};

const styles = StyleSheet.create({
  calendar: {
    marginHorizontal: px(horizontalPadding),
    height: px(80),
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 26,
    marginBottom: 10,
  },
  headerIcon: {
    width: 15,
    height: 15,
  },
  headerText: {
    paddingHorizontal: 20,
  },
});

export default TopCalendar;
